/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_verify_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Found a mistake? Tell us — corrections from readers are the fastest way we improve.`)
};

const es_about_verify_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Encontraste un error? Cuéntanoslo — las correcciones de los lectores son la forma más rápida de mejorar.`)
};

const de_about_verify_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einen Fehler gefunden? Sag uns Bescheid — Korrekturen von Lesern sind der schnellste Weg, wie wir besser werden.`)
};

const nl_about_verify_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een fout gevonden? Laat het ons weten — correcties van lezers zijn de snelste manier waarop we verbeteren.`)
};

const fr_about_verify_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez trouvé une erreur ? Dites-le-nous — les corrections des lecteurs sont le moyen le plus rapide de nous améliorer.`)
};

const it_about_verify_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai trovato un errore? Faccelo sapere — le correzioni dei lettori sono il modo più rapido per migliorare.`)
};

const pt_br2_about_verify_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontrou um erro? Nos conte — correções de leitores são a forma mais rápida de melhorarmos.`)
};

const pt_about_verify_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontrou um erro? Diga-nos — as correções dos leitores são a forma mais rápida de melhorarmos.`)
};

const ja_about_verify_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`誤りを見つけましたか？お知らせください — 読者からの指摘は、私たちが改善する最も速い方法です。`)
};

const zh_about_verify_p = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发现错误了吗？请告诉我们——读者的指正是我们改进最快的方式。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_verify_p = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_verify_p(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_verify_p", locale)
	if (locale === "en") return en_about_verify_p(inputs)
	if (locale === "es") return es_about_verify_p(inputs)
	if (locale === "de") return de_about_verify_p(inputs)
	if (locale === "nl") return nl_about_verify_p(inputs)
	if (locale === "fr") return fr_about_verify_p(inputs)
	if (locale === "it") return it_about_verify_p(inputs)
	if (locale === "pt-BR") return pt_br2_about_verify_p(inputs)
	if (locale === "pt") return pt_about_verify_p(inputs)
	if (locale === "ja") return ja_about_verify_p(inputs)
	return zh_about_verify_p(inputs)
};